import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";

import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ProgramDialog from "../ProgramDialog";
import ThemeDialog from "../ThemeDialog";
import LessonDialog from "../LessonDialog";
import DeleteConfirmationModal from "../../../../../../../ui/DeleteConfirmationModal";
import NoData from "../NoData";
import AddButton from "../../../../../../../ui/AddButton";
import LessonInfo from "../LessonInfo";

const useStyles = makeStyles({
  content: {
    marginTop: 17,
    "& .MuiFormControl-root": {
      marginTop: "10px",
      width: "100%"
    }
  },
  addTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: "7px",
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px",
      marginRight: 20
    }
  }
});

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      "&  p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px"
      },
      "& svg": {
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  }
}))(MuiExpansionPanelDetails);

export default function PlanExpandPanel({
  allModuleVolume,
  showProgramDialog,
  openProgramDialog,
  closeProgramDialog,
  updateModuleVolume,
  deleteModuleVolume,
  allModuleThemeVolume,
  allModuleAbilityTheme,
  showThemeDialog,
  openThemeDialog,
  showThemeEditDialog,
  openThemeEditDialog,
  closeThemeEditDialog,
  closeThemeDialog,
  moduleAbility,
  addModuleThemeVolume,
  updateModuleTheme,
  deleteModuleThemeVolume,
  allModuleLessonTheme,
  deleteModuleLesson,
  allLessonType,
  addModuleLesson,
  updateModuleLesson
}) {
  const { content, addTitle } = useStyles();
  const [expandedVolume, setExpandedVolume] = React.useState();
  const [expandedTheme, setExpandedTheme] = React.useState();
  const [expandedLesson, setExpandedLesson] = React.useState();
  const [activeVolume, setActiveVolume] = React.useState();
  const [activeTheme, setActiveTheme] = React.useState();
  const [activeLesson, setActiveLesson] = React.useState();
  const [openDeleteVolumeModal, setOpenDeleteVolumeModal] = React.useState(
    false
  );
  const [openDeleteThemeModal, setOpenDeleteThemeModal] = React.useState(false);
  const [openDeleteLessonModal, setOpenDeleteLessonModal] = React.useState(
    false
  );

  const [showLessonDialog, setShowLessonDialog] = React.useState(false);
  const [showLessonEditDialog, setShowLessonEditDialog] = React.useState(false);

  // const [digigtalMaterials, setdigigtalMaterials] = React.useState();

  const [lesson, setLesson] = React.useState({
    themeId: "",
    main: {
      number: "",
      name: "",
      type: "",
      conduct: "",
      requirements: ""
    },
    content: {
      description: ""
    },
    sites: []
  });

  /*   const addDigitalMaterails = () => {
    const materials = [...ability];
    values.push({
      url: "ixbt.com",
      lessonId: 1,
      name: "IXBT",
      id: 1
    });
    setdigigtalMaterials(materials);
  }; */

  const initialTheme = {
    volumeId: "",
    main: {
      number: "",
      name: ""
    },
    ability: []
  };

  const initialLesson = {
    themeId: "",
    main: {
      number: "",
      name: "",
      type: "",
      conduct: "",
      requirements: ""
    },
    content: {
      description: ""
    },
    sites: []
  };

  const [theme, setTheme] = React.useState({
    volumeId: "",
    main: {
      number: "",
      name: ""
    },
    ability: []
  });

  React.useEffect(() => {
    if (activeLesson) {
      const lesson = {
        themeId: activeLesson.themeId,
        main: {
          number: activeLesson.number,
          name: activeLesson.name,
          type: activeLesson.typeId,
          conduct: activeLesson.conductId,
          requirements: activeLesson.requirements
        },
        content: {
          description: activeLesson.description
        },
        sites: []
      };
      setLesson(lesson);
    }
  }, [activeLesson]);

  React.useEffect(() => {
    if (activeTheme) {
      const theme = {
        volumeId: activeTheme.volumeId,
        main: {
          number: activeTheme.number,
          name: activeTheme.name
        },
        ability: allModuleAbilityTheme.filter(
          item => item.themeId === activeTheme.id
        )
      };
      setTheme(theme);
    }
  }, [activeTheme, allModuleAbilityTheme]);

  const changeAbility = (field, value) => {
    const newState = {
      ...theme,
      [field]: value
    };
    setTheme(newState);
  };

  const changeTheme = event => {
    const newState = {
      ...theme,
      main: {
        ...theme.main,
        [event.target.name]: event.target.value
      }
    };
    setTheme(newState);
  };

  const changeLesson = event => {
    const newState = {
      ...lesson,
      main: {
        ...lesson.main,
        [event.target.name]: event.target.value
      }
    };
    setLesson(newState);
  };

  const changeLessonConduct = (event, value) => {
    const newState = {
      ...lesson,
      main: {
        ...lesson.main,
        conduct: value
      }
    };
    setLesson(newState);
  };

  const changeLessonType = (event, value) => {
    const newState = {
      ...lesson,
      main: {
        ...lesson.main,
        type: value
      }
    };
    setLesson(newState);
  };

  const handleChangeVolumePanel = panel => (event, newExpandedVolume) => {
    setExpandedVolume(newExpandedVolume ? panel : false);
  };

  const handleChangeVolumeThemePanel = panel => (
    event,
    newExpandedVolumeTheme
  ) => {
    setExpandedTheme(newExpandedVolumeTheme ? panel : false);
  };

  const handleChangeLessonPanel = panel => (event, newExpandedLesson) => {
    setExpandedLesson(newExpandedLesson ? panel : false);
  };

  const setStateVolume = id => {
    const value = allModuleVolume.find(item => item.id === id);
    setActiveVolume(value);
  };

  const setStateThemeVolume = id => {
    const value = allModuleThemeVolume.find(item => item.id === id);
    setActiveTheme(value);
  };

  const setStateLesson = id => {
    const value = allModuleLessonTheme.find(item => item.id === id);
    setActiveLesson(value);
  };

  const changeVolume = event => {
    setActiveVolume({
      ...activeVolume,
      [event.target.name]: event.target.value
    });
  };

  const closeLessonDialog = () => {
    setShowLessonDialog(false);
  };

  const closeLessonEditDialog = () => {
    setShowLessonEditDialog(false);
  };

  return (
    <div className={content}>
      <ProgramDialog
        title={`Редактировать раздел ${activeVolume && activeVolume.number}`}
        showProgramDialog={showProgramDialog}
        closeProgramDialog={closeProgramDialog}
        volume={activeVolume}
        changeVolume={changeVolume}
        updateModuleVolume={updateModuleVolume}
      />
      <ThemeDialog
        title={`Добавить новую тему в Раздел ${activeVolume &&
          activeVolume.number}`}
        type="add"
        showThemeDialog={showThemeDialog}
        closeThemeDialog={closeThemeDialog}
        moduleAbility={moduleAbility}
        theme={theme}
        changeAbility={changeAbility}
        changeTheme={changeTheme}
        addModuleThemeVolume={addModuleThemeVolume}
        activeVolumeId={activeVolume && activeVolume.id}
      />
      <ThemeDialog
        title={`Редактировать тему ${activeTheme && activeTheme.name}`}
        showThemeDialog={showThemeEditDialog}
        closeThemeDialog={closeThemeEditDialog}
        moduleAbility={moduleAbility}
        theme={theme}
        changeAbility={changeAbility}
        changeTheme={changeTheme}
        activeThemeId={activeTheme && activeTheme.id}
        activeVolumeId={activeVolume && activeVolume.id}
        updateModuleTheme={updateModuleTheme}
      />

      <LessonDialog
        type="add"
        title={`Добавить занятие в тему ${activeTheme && activeTheme.name}`}
        showLessonDialog={showLessonDialog}
        closeLessonDialog={closeLessonDialog}
        allLessonType={allLessonType}
        lesson={lesson}
        changeLesson={changeLesson}
        changeLessonConduct={changeLessonConduct}
        activeThemeId={activeTheme && activeTheme.id}
        changeLessonType={changeLessonType}
        addModuleLesson={addModuleLesson}
      />

      <LessonDialog
        title={`Редактировать занятие ${activeLesson && activeLesson.name}`}
        showLessonDialog={showLessonEditDialog}
        closeLessonDialog={closeLessonEditDialog}
        allLessonType={allLessonType}
        lesson={lesson}
        changeLesson={changeLesson}
        changeLessonConduct={changeLessonConduct}
        changeLessonType={changeLessonType}
        activeThemeId={activeTheme && activeTheme.id}
        updateModuleLesson={updateModuleLesson}
        activeLessonId={activeLesson && activeLesson.id}
      />

      <DeleteConfirmationModal
        open={openDeleteVolumeModal}
        handleClose={() => setOpenDeleteVolumeModal(false)}
        modalText="Удалить раздел"
        additionalText={activeVolume && activeVolume.name}
        onConfirm={() =>
          deleteModuleVolume(activeVolume.id) || setOpenDeleteVolumeModal(false)
        }
      />
      <DeleteConfirmationModal
        open={openDeleteThemeModal}
        handleClose={() =>
          setOpenDeleteThemeModal(false) || setTheme(initialTheme)
        }
        modalText="Удалить тему"
        additionalText={activeTheme && activeTheme.name}
        onConfirm={() =>
          deleteModuleThemeVolume(activeTheme.id) || setTheme(initialTheme)
        }
      />
      <DeleteConfirmationModal
        open={openDeleteLessonModal}
        handleClose={() =>
          setOpenDeleteLessonModal(false) || setLesson(initialLesson)
        }
        modalText="Удалить занятие"
        additionalText={activeLesson && activeLesson.name}
        onConfirm={() =>
          deleteModuleLesson(activeLesson.id) || setLesson(initialLesson)
        }
      />

      {allModuleVolume.map(volume => {
        return (
          <ExpansionPanel
            key={volume.id}
            square
            expanded={expandedVolume === `panel${volume.id}`}
            onChange={handleChangeVolumePanel(`panel${volume.id}`)}
          >
            <ExpansionPanelSummary>
              <div style={{ display: "flex" }}>
                {expandedVolume === `panel${volume.id}` ? (
                  <ArrowDropDownIcon />
                ) : (
                  <ArrowRightIcon />
                )}
                <Typography>{`Раздел ${volume.number}. ${volume.name}`}</Typography>
              </div>
              <div style={{ paddingRight: "16px" }}>
                <Tooltip title="Редактировать" placement="top-start">
                  <IconButton
                    size="small"
                    onClick={event =>
                      event.stopPropagation() ||
                      setStateVolume(volume.id) ||
                      openProgramDialog(true)
                    }
                  >
                    <EditOutlinedIcon
                      fontSize="small"
                      style={{ fill: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Удалить" placement="top-start">
                  <IconButton
                    size="small"
                    onClick={event =>
                      event.stopPropagation() ||
                      setStateVolume(volume.id) ||
                      setOpenDeleteVolumeModal(true)
                    }
                  >
                    <DeleteForeverOutlinedIcon
                      fontSize="small"
                      style={{ fill: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className={addTitle}>
                <span>Темы</span>
                <AddButton
                  onClick={() =>
                    setStateVolume(volume.id) ||
                    openThemeDialog(true) ||
                    setTheme(initialTheme)
                  }
                />
              </div>
              {allModuleThemeVolume.length === 0 ? (
                <NoData
                  title="Темы в данном разделе пока отсутствуют"
                  desc="Добавьте темы и занятия"
                />
              ) : (
                allModuleThemeVolume
                  .filter(theme => theme.volumeId === volume.id)
                  .map(theme => {
                    return (
                      <ExpansionPanel
                        key={theme.id}
                        square
                        expanded={expandedTheme === `panel${theme.id}`}
                        onChange={handleChangeVolumeThemePanel(
                          `panel${theme.id}`
                        )}
                      >
                        <ExpansionPanelSummary>
                          <div style={{ display: "flex" }}>
                            {expandedTheme === `panel${theme.id}` ? (
                              <ArrowDropDownIcon />
                            ) : (
                              <ArrowRightIcon />
                            )}
                            <Typography>{`Тема ${theme.number}. ${theme.name}`}</Typography>
                          </div>
                          <div style={{ paddingRight: "16px" }}>
                            <Tooltip
                              title="Редактировать"
                              placement="top-start"
                            >
                              <IconButton
                                size="small"
                                onClick={event =>
                                  event.stopPropagation() ||
                                  setStateThemeVolume(theme.id) ||
                                  openThemeEditDialog()
                                }
                              >
                                <EditOutlinedIcon
                                  fontSize="small"
                                  style={{ fill: "#93A7BE" }}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Удалить" placement="top-start">
                              <IconButton
                                size="small"
                                onClick={event =>
                                  event.stopPropagation() ||
                                  setStateThemeVolume(theme.id) ||
                                  setOpenDeleteThemeModal(true) ||
                                  setTheme(initialTheme)
                                }
                              >
                                <DeleteForeverOutlinedIcon
                                  fontSize="small"
                                  style={{ fill: "#93A7BE" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <div className={addTitle}>
                            <span>Занятия</span>
                            <AddButton
                              onClick={() =>
                                setStateThemeVolume(theme.id) ||
                                setShowLessonDialog(true) ||
                                setLesson(initialLesson)
                              }
                            />
                          </div>
                          {allModuleLessonTheme.length === 0 ? (
                            <NoData
                              title="Занятия в данной теме пока отсутствуют"
                              desc="Добавьте занятия"
                            />
                          ) : (
                            allModuleLessonTheme
                              .filter(lesson => lesson.themeId === theme.id)
                              .map(lesson => {
                                return (
                                  <ExpansionPanel
                                    key={lesson.id}
                                    square
                                    expanded={
                                      expandedLesson === `panel${lesson.id}`
                                    }
                                    onChange={handleChangeLessonPanel(
                                      `panel${lesson.id}`
                                    )}
                                  >
                                    <ExpansionPanelSummary>
                                      <div style={{ display: "flex" }}>
                                        {expandedLesson ===
                                        `panel${lesson.id}` ? (
                                          <ArrowDropDownIcon />
                                        ) : (
                                          <ArrowRightIcon />
                                        )}
                                        <Typography>{`${lesson.typeName} ${lesson.number}. ${lesson.name}`}</Typography>
                                      </div>
                                      <div style={{ paddingRight: "16px" }}>
                                        <Tooltip
                                          title="Редактировать"
                                          placement="top-start"
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={event =>
                                              event.stopPropagation() ||
                                              setShowLessonEditDialog(true) ||
                                              setStateLesson(lesson.id)
                                            }
                                          >
                                            <EditOutlinedIcon
                                              fontSize="small"
                                              style={{ fill: "#93A7BE" }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                          title="Удалить"
                                          placement="top-start"
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={event =>
                                              event.stopPropagation() ||
                                              setOpenDeleteLessonModal(true) ||
                                              setStateLesson(lesson.id) ||
                                              setLesson(initialLesson)
                                            }
                                          >
                                            <DeleteForeverOutlinedIcon
                                              fontSize="small"
                                              style={{ fill: "#93A7BE" }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                      <LessonInfo
                                        form={lesson.conductName}
                                        name={lesson.name}
                                        purpose={lesson.requirements}
                                      />
                                    </ExpansionPanelDetails>
                                  </ExpansionPanel>
                                );
                              })
                          )}
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    );
                  })
              )}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </div>
  );
}
